/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="109.04"
        height="78.2"
        viewBox="0 0 109.04 78.2"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M54.48 0a1.26 1.26 0 0 1 1.24 1.12V17.5a1.25 1.25 0 0 1-2.49.12V1.25A1.25 1.25 0 0 1 54.48 0ZM92.2 16.06a1.25 1.25 0 0 1 1.77 0 1.22 1.22 0 0 1 .09 1.66l-.09.1-11.49 11.43a1.243 1.243 0 1 1-1.85-1.66l.09-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M74.13 4.79a1.25 1.25 0 0 1 2.35.84v.12l-6.23 15a1.25 1.25 0 1 1-2.36-.83l.05-.12ZM105.01 33.8a1.25 1.25 0 0 1 1.05 2.27l-.12.05-15.07 6.13a1.25 1.25 0 0 1-1-2.26l.11-.06ZM2.6 33.86a1.26 1.26 0 0 1 1.51-.72h.12l15 6.27a1.25 1.25 0 0 1 .67 1.64 1.24 1.24 0 0 1-1.51.71h-.12l-15-6.27a1.24 1.24 0 0 1-.67-1.62ZM33.27 4.09a1.26 1.26 0 0 1 1.58.56v.12l6.2 15a1.25 1.25 0 1 1-2.26 1.07v-.12l-6.2-15a1.25 1.25 0 0 1 .68-1.63Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M14.98 16.04a1.24 1.24 0 0 1 1.67-.09l.1.09 11.49 11.49a1.25 1.25 0 0 1-1.67 1.85l-.1-.09-11.49-11.48a1.27 1.27 0 0 1 0-1.77ZM54.48 27.16a29.51 29.51 0 0 1 29.51 29.46 1.25 1.25 0 0 1-2.5 0 27 27 0 1 0-54 0 1.25 1.25 0 0 1-2.5 0 29.5 29.5 0 0 1 29.49-29.46Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M107.72 55.41a1.27 1.27 0 0 1 1.32 1.19 1.25 1.25 0 0 1-1.19 1.31H1.22A1.24 1.24 0 0 1 0 56.64a1.26 1.26 0 0 1 1.09-1.22h106.63ZM89.99 65.56a1.25 1.25 0 0 1 .13 2.49H18.97a1.25 1.25 0 0 1-.12-2.49ZM77.31 75.71a1.25 1.25 0 0 1 .13 2.49H31.66a1.24 1.24 0 0 1-1.31-1.18 1.25 1.25 0 0 1 1.18-1.32h45.78Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SunsetOverWaterHorizonIcon';

export default Icon;
